export const API_BASE_PERMISSION = '/rental/scm/permission';
export const API_BASE_ENUMS = `/rental/scm/getAllEnum`;
export const API_BASE_ENCRYPT_KEY = '/rental/scm/getEncryptKey';
export const API_BASE_USERINFO = '/rental/scm/userInfo';
